const LOG_PREFIX = '[Search]';
const LOG_PREFIX_WELCOME_BANNER = '[Search]::[Welcome Banner]';

const highLightElements = {
  start: '<strong>',
  end: '</strong>',
};

const QUERY_SUGGESTION_MAX_LENGTH = 59;
const QUERY_SUGGESTION_MIN_LENGTH = 3;

const ids = {
  supportSearch: 'support-search',
};

export {
  LOG_PREFIX,
  LOG_PREFIX_WELCOME_BANNER,
  QUERY_SUGGESTION_MAX_LENGTH,
  QUERY_SUGGESTION_MIN_LENGTH,
  highLightElements,
  ids,
};
